import React from "react";
import { observer } from "mobx-react";
import { withStyles } from "@material-ui/styles";

import {
  TableContainer,
  Table,
  TableHead,
  TableBody,
  TableCell,
  TableRow,
  Button,
  Typography,
  Select,
  MenuItem,
  FormControl,
  Box,
  Card,
  CardContent,
} from "@material-ui/core";
import Paper from "@material-ui/core/Paper";
import location from "../../stores/locationStore";
import DeleteIcon from "@material-ui/icons/Delete";
import HistoryIcon from "@material-ui/icons/History";
import { toJS } from "mobx";
import { withAlert } from "react-alert";
import { Link } from "react-router-dom";
import user from "../../stores/userStore";
import history from "../../components/history";
import { indigo } from "@material-ui/core/colors";
const background = indigo[500];
const styles = (theme) => ({
  tableContainer: {
    marginTop: 20,
    height: 500,
  },
  table: {
    minWidth: 650,
  },
  button: {
    margin: 0,
  },
  cardDiv: {
    maxWidth: 200,
  },
  cardBtn: {
    width: "100%",
  },
  title: {},
});

const View = observer(
  class LocationList extends React.Component {
    constructor(props) {
      super(props);
      this.state = { btnDelete: false, 담당: "전체" };
    }
    componentDidMount = async () => {
      location.getLocationList();
    };

    DeleteClick = async (locname) => {
      try {
        this.setState({ btnDelete: true });
        if (window.confirm("삭제하시겠습니까?")) {
          if (window.prompt("기관명을 입력하세요") == locname) {
            await location.deleteLocation(locname);
            this.props.alert.show("삭제되었습니다.");
          } else {
            this.props.alert.show("기관명이 올바르지 않습니다");
          }
        }
        this.setState({ btnDelete: false });
      } catch (error) {
        this.setState({ btnDelete: false });
      }
    };
    handleChange = async (e) => {
      await this.setState({
        [e.target.name]: e.target.value,
      });
    };

    render() {
      const { classes } = this.props;
      let locationList = toJS(location.locationList).sort(function (a, b) {
        return a.locname < b.locname ? -1 : a.locname > b.locname ? 1 : 0;
      });
      const USER = toJS(user.user);
      const ignoreArr = ["이창직", "임현수", "전승진"];
      const userList = toJS(user.userList)
        .filter((item) => !ignoreArr.includes(item.username))
        .sort(function (a, b) {
          return a.username < b.username ? -1 : a.username > b.username ? 1 : 0;
        });
      if (this.state["담당"] && this.state["담당"] != "전체") {
        locationList = locationList.filter(
          (item) => item["detail"]["담당"] == this.state["담당"]
        );
      }

      return (
        <div>
          <div className={classes.cardDiv}>
            <Paper>
              <Box
                bgcolor={background}
                color="white"
                p={2}
                className={classes.title}
              >
                담당 기관보기
              </Box>
              <FormControl style={{ minWidth: 200 }}>
                <Select
                  variant="outlined"
                  margin="normal"
                  name="담당"
                  label="담당"
                  defaultValue="전체"
                  onChange={this.handleChange}
                >
                  <MenuItem value="전체">전체</MenuItem>
                  {userList.map((item) => {
                    return (
                      <MenuItem value={item.username}>{item.username}</MenuItem>
                    );
                  })}
                </Select>
              </FormControl>
            </Paper>
          </div>

          <Typography variant="h6" id="tableTitle" component="div">
            기관 수 : {locationList.length}
          </Typography>
          <TableContainer component={Paper} className={classes.tableContainer}>
            <Table
              className={classes.table}
              aria-label="simple table"
              stickyHeader
            >
              <TableHead>
                <TableRow>
                  <TableCell align="center">기관명</TableCell>
                  <TableCell align="center">담당</TableCell>
                  <TableCell align="center">지역</TableCell>
                  <TableCell align="center">유지보수</TableCell>
                  <TableCell align="center">history</TableCell>
                  {USER.admin == "Y" && (
                    <TableCell align="center">삭제</TableCell>
                  )}
                </TableRow>
              </TableHead>
              <TableBody>
                {locationList.map((location) => (
                  <TableRow key={location._id}>
                    <TableCell align="center">
                      <Link
                        to={"/location/" + location.locname}
                        style={{ textDecoration: "none" }}
                      >
                        <Button color="primary"> {location.locname}</Button>
                      </Link>
                    </TableCell>
                    <TableCell align="center">
                      {location["detail"]["담당"]}
                    </TableCell>
                    <TableCell align="center">
                      {location["detail"]["지역"]}
                    </TableCell>
                    <TableCell align="center">
                      {location["detail"]["유지보수"]}
                    </TableCell>
                    <TableCell align="center">
                      {" "}
                      <Link
                        to={"/history/" + location.locname}
                        style={{ textDecoration: "none" }}
                      >
                        <Button
                          variant="contained"
                          color="primary"
                          className={classes.button}
                          startIcon={<HistoryIcon />}
                        >
                          History
                        </Button>
                      </Link>
                    </TableCell>

                    {USER.admin == "Y" && (
                      <TableCell align="center">
                        {" "}
                        <Button
                          variant="contained"
                          color="secondary"
                          className={classes.button}
                          startIcon={<DeleteIcon />}
                          disabled={this.state.btnDelete}
                          userid={location.locname}
                          onClick={() => this.DeleteClick(location.locname)}
                        >
                          Delete
                        </Button>
                      </TableCell>
                    )}
                  </TableRow>
                ))}
              </TableBody>
            </Table>
          </TableContainer>
        </div>
      );
    }
  }
);

const alertView = withAlert()(View);
export default withStyles(styles)(alertView);
